import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * A gain or loss: coloured only for P/L, always with an arrow so colour is never the only cue
 * (CLAUDE.md §6.9).
 */
export function PlValue({
  value,
  children,
  className,
}: {
  value: number;
  children: ReactNode;
  className?: string;
}) {
  if (value === 0) return <span className={cn('tabular', className)}>{children}</span>;
  const up = value > 0;
  return (
    <span
      className={cn(
        'tabular inline-flex items-center gap-0.5',
        up ? 'text-positive' : 'text-negative',
        className,
      )}
    >
      {up ? (
        <ArrowUpRight className="size-3.5" aria-hidden />
      ) : (
        <ArrowDownRight className="size-3.5" aria-hidden />
      )}
      {children}
    </span>
  );
}
